<template>
  <div class="afdc-fuel-filters-box">
    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-cng-fill-type">{{ $t('Fill type') }}</label>
      <div class="afdc-col-sm-8">
        <select class="afdc-form-control afdc-custom-select" v-model="queryCngFillType" id="afdc-analyze-cng-fill-type">
          <option v-for="option in fillTypeOptions" v-bind:key="option.key" v-bind:value="option.key">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="afdc-form-group afdc-row">
      <label class="afdc-col-sm-4 afdc-col-form-label" for="afdc-analyze-cng-levels">{{ $t('Fill pressure') }}</label>
      <div class="afdc-col-sm-8">
        <select-multiple-dropdown v-model="queryCngPsis" v-bind:options="psiOptions" id="afdc-analyze-cng-levels"/>
      </div>
    </div>

    <div class="afdc-row">
      <div class="afdc-col-sm-8 afdc-offset-sm-4">
        <div class="afdc-custom-control afdc-custom-checkbox">
          <input type="checkbox" class="afdc-custom-control-input" v-model="queryCngHasRng" id="afdc-analyze-cng-rng">
          <label class="afdc-custom-control-label" for="afdc-analyze-cng-rng">{{ $t('Include only stations that sell renewable natural gas (RNG)') }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectMultipleDropdown from '@/components/SelectMultipleDropdown.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';
import reject from 'lodash/reject';

export default {
  components: {
    SelectMultipleDropdown,
  },

  computed: {
    fillTypeOptions() {
      // Remove the 'B' (both) option from the select menu, since this isn't
      // actually a valid filter option (it's just a virtual option that's a
      // possible return value).
      return reject(this.$store.getters.loaderCngFillTypes, { key: 'B' });
    },

    psiOptions() {
      return this.$store.getters.loaderCngPsis;
    },

    queryCngFillType: syncInputRouteQuery('cng_fill_type'),
    queryCngPsis: syncInputRouteQuery('cng_psis'),
    queryCngHasRng: syncInputRouteQuery('cng_has_rng'),
  },
};
</script>

<style lang="scss">
</style>
